import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Checkbox, ControlLabel, FormGroup, FormControl, Panel } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import { legit } from 'apex-legit-service';
import { ALL_REQUESTED_PERMISSIONS } from 'common';
import { LEGIT_SERVICE_CONFIG } from './constants';
import messages from './messages';
import { setApexUserChecked } from './actions';
import { selectIsApexUserChecked } from './selectors';

import styles from './styles.css';
import { setRumUser } from '../../utils/datadog';

class Login extends Component {

  constructor(props) {
    super(props);
    // Initialize with preference that entered the redux store via localStorage
    this.state = { apexUser: props.isApexUserChecked, username: props.username };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const value = (event.target.type === 'checkbox') ? event.target.checked : event.target.value;
    this.setState({ [event.target.getAttribute('id')]: value });
  }

  handleSubmit(event) {
    event.preventDefault();
    event.stopPropagation();
    this.props.onSubmit(this.state);
    setRumUser({ loginType: 'legacy' });
  }

  render() {
    return (
      <Panel className={styles.loginPanel}>
        <h1>{messages.title.defaultMessage}</h1>
        <Panel.Body className={styles.Padding}>
          <form action="" onSubmit={this.handleSubmit}>
            <FormGroup controlId="username">
              <ControlLabel><FormattedMessage {...messages.username} /></ControlLabel>
              <FormControl defaultValue={this.state.username} type="text" required autoComplete="username" onChange={this.handleChange} />
            </FormGroup>
            <FormGroup controlId="password">
              <ControlLabel><FormattedMessage {...messages.password} /></ControlLabel>
              <FormControl type="password" required autoComplete="password" onChange={this.handleChange} />
            </FormGroup>
            <FormGroup controlId="apexUser">
              <Checkbox id="apexUser" className={styles['apex-checkbox']} checked={this.state.apexUser} onChange={this.handleChange}><FormattedMessage {...messages.apexuser} /></Checkbox>
            </FormGroup>
            <Button type="submit" bsStyle="primary" className={`form-control ${styles.loginButton}`}><FormattedMessage {...messages.submit} /></Button>
          </form>
        </Panel.Body>
      </Panel>
    );
  }
}

Login.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isApexUserChecked: PropTypes.bool.isRequired,
  username: PropTypes.string.isRequired,
};

/* istanbul ignore next */
const mapStateToProps = (state) => ({ isApexUserChecked: selectIsApexUserChecked(state) });

/* istanbul ignore next */
const mapDispatchToProps = (dispatch) => ({
  onSubmit: (params) => {
    dispatch(legit.login(
      LEGIT_SERVICE_CONFIG,
      {
        apexUser: false,
        ...params,
        permissions: ALL_REQUESTED_PERMISSIONS,
      },
    ));
    dispatch(setApexUserChecked(params));
  },
});

export { NAMESPACE, LEGIT_SERVICE_CONFIG } from './constants';
export { default as reducer } from './reducer';
export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/LegacyLogin.js